export default "__VITE_ASSET__Cxr6JiOD__"